<template>
  <div>
    <vs-button size="large" @click="selectButton('OS');" style="height: 100px;" :color="btnColorOs"
      type="filled">&nbsp;OS&nbsp;</vs-button>
    &nbsp;&nbsp;
    <vs-button size="large" @click="selectButton('CS')" style="height: 100px;" :color="btnColorCs"
      type="filled">&nbsp;CS&nbsp;</vs-button>

  </div>
</template>

<script>
export default {
  props: {
    defaultValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedValue: null,
      btnColorOs: 'gray',
      btnColorCs: 'gray',
    };
  },
  mounted() {
    this.selectedValue = this.defaultValue;
    this.selectButton(this.defaultValue);
  },
  methods: {
    selectButton(value) {
      if (value == 'OS') {
        this.btnColorOs = 'primary';
        this.btnColorCs = 'gray';
      } else if (value == 'CS') {
        this.btnColorOs = 'gray';
        this.btnColorCs = 'primary';
      }
      this.selectedValue = value;
    },
  },
  watch: {
    selectedValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
